import React from 'react';
import { Button, Icon, Intent, Tag } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { DateDropdownPicker } from '@zaiusinc/hera';
import { DurationInputArg2 } from 'moment';
import styles from '../DataSyncAnalyticsPage.module.sass';

interface DateRangeOption {
  key: string;
  unit: DurationInputArg2;
  quantity: number;
  label: string;
}

interface TimeframeOption {
  key: string;
  start?: string;
  end?: string;
}

interface AnalyticsHeaderProps {
  dataSyncName: string;
  healthLabel?: string;
  healthIntent?: Intent;
  dateRangeOptions: DateRangeOption[];
  timeframeKey: string;
  timeframeValue?: [string, string];
  analyticsTimeframeFilterClassName: string;
  onBack: () => void;
  onViewActivityLogs: () => void;
  onTimeframeChange: (option: TimeframeOption) => void;
}

const AnalyticsHeader: React.FC<AnalyticsHeaderProps> = ({
  dataSyncName,
  healthLabel,
  healthIntent,
  dateRangeOptions,
  timeframeKey,
  timeframeValue,
  analyticsTimeframeFilterClassName,
  onBack,
  onViewActivityLogs,
  onTimeframeChange,
}) => (
  <>
    <button className={styles.backLink} onClick={onBack}>
      <Icon icon={IconNames.CHEVRON_LEFT} />
      <span>Sync Manager</span>
    </button>

    <div className={styles.topRow}>
      <div className={styles.titleWrap}>
        <h1 className={styles.title}>{dataSyncName}</h1>
        {healthLabel && healthIntent && (
          <Tag intent={healthIntent} round={true}>
            {healthLabel}
          </Tag>
        )}
      </div>

      <div className={styles.topRowActions}>
        <Button
          className={styles.activityLogsButton}
          icon={IconNames.TIME}
          outlined={true}
          intent={Intent.PRIMARY}
          onClick={onViewActivityLogs}
        >
          View Activity Logs
        </Button>
        <div className={styles.rangeControl}>
          <span className={styles.rangeControlLabel}>Date range</span>
          <DateDropdownPicker
            dateRangeOptions={dateRangeOptions}
            onChange={onTimeframeChange}
            initialActiveOptionKey={timeframeKey}
            value={timeframeValue}
            position={'right'}
            loading={false}
            popover={{
              position: 'bottom-right',
              className: analyticsTimeframeFilterClassName,
            }}
          />
        </div>
      </div>
    </div>
  </>
);

export default AnalyticsHeader;
